import { FC } from 'react'
import { GameID } from '../types'
import { useTimings } from '../hooks/useTimings'
import StatRow from './StatRow'

type Props = {
	gameId: GameID
}

const Timecard: FC<Props> = ({ gameId }) => {
	const { timings, words } = useTimings(gameId)

	return (
		<div className="timecard">
			<h2>Timecard</h2>
			<div className="post-game-stats-table">
				{words.map((word, index) => (
					<StatRow
						key={word}
						label={word}
						value={
							<>
								{timings[index] - (timings[index - 1] || 0)} <small>seconds</small>
							</>
						}
					/>
				))}
			</div>
		</div>
	)
}

export default Timecard
